<tam-dialog tid="calendar_dialog" class="calendar-dialog threaddetail-sidesheet-status"
    [ngClass]="{'event-duplicate':isShowDuplicateTip}" (closeminDialog)="closemin()" [opened]="opened"
    [dialogWidth]="dialogWidth" [titleName]="titleName" (keydown.esc)="onEnter($event)"
    [closable]="attachmentUploading||attachmentRenaming" (keyup)="keySend($event)" [hidden]="isDialogHidden" #dialogRef>
    <ng-template #title *ngIf="!isPlugInEditNoteMode">
        <span class="dialog-title">{{titleName}}</span>
        <smart-icon class="dialog-min dark" name="substract" (click)="windowMinimize()" [hidden]="true"></smart-icon>
        <smart-icon class="dialog-close dark" name="close" (click)="clickClose('cancel', $event)"
            [hidden]="attachmentUploading||attachmentRenaming">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="note-content" [ngClass]="{'single-layer-content':isSingleTemplate}">
            <div class="flex-box" [ngClass]="{'addin-privacy':isSingleTemplate}">
                <div [ngClass]="{'pull-left-privacy':isPrivacy}" class="pull-left control" tid="event_type">
                    <div class="calendar-type-label" *ngIf="!isSingleTemplate">
                        <span> {{'calendar.event_type' | stringLiterals}} </span>
                    </div>
                    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" #eventType class="calendar-type-list"
                        [data]="_noteTypes" [(ngModel)]="_noteTypeDefalult" [textField]="'name'" [valueField]="'id'"
                        [filterable]="true" (selectionChange)="selectionChange($event)"
                        (filterChange)="handleFilter($event)" (focus)="eventType.toggle(true)"
                        (mousedown)="$event.preventDefault()">
                    </kendo-dropdownlist>

                    <tam-priority-input class="priority-input" *ngIf="isSingleTemplate&&sentimentConfig"
                        [config]="sentimentConfig" [valueChangeSubject]="valueChangeSubject">
                    </tam-priority-input>
                </div>

                <div class="pull-right" [ngClass]="{'pull-right-privacy':isPrivacy}"
                    *ngIf="privacyEnabled &&(_noteAction =='create-note'||isPlugInEditNoteMode)" tid="event_privacy">
                    <label style="width: 67px;">
                        <span>{{'general.privacy' | stringLiterals}} &nbsp;&nbsp;&nbsp;&nbsp; </span>
                        <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" #dropDownEl [data]="_privacyList"
                            [(ngModel)]="privacyListDefalult" [textField]="'name'" [valueField]="'id'"
                            (selectionChange)="privacyChanged($event)" [filterable]="true"
                            (filterChange)="privacyHandleFilter($event)" (focus)="dropDownEl.toggle(true)"
                            (mousedown)="$event.preventDefault()">
                        </kendo-dropdownlist>
                    </label>
                </div>
            </div>
            <div *ngIf="isNeedReload"><label class="template-change">{{'calendar.save_template_configuration' |
                    stringLiterals}},
                    {{'calendar.please' | stringLiterals}} <span class="template-reload"
                        (click)="onClickReload()">{{'calendar.reload' | stringLiterals}}.</span></label></div>
            <hr [ngClass]="{'hr-one-layer':isSingleTemplate}">

            <label *ngIf="isSingleTemplate" tam-checkbox class="checkbox" [disabled]='true' [(ngModel)]="isCheckbox">
                {{'addin.this_is_event' | stringLiterals }}</label>
            <div *ngIf="isShowEventArea" [style.width.px]="dialogWidth">
                <!-- location-->
                <div class="control" [ngClass]="{'single-layer-control':isSingleTemplate}" tid="Location" kendoTooltip
                    position="right" tooltipClass="tooltip-adjust-right">
                    <div [ngClass]="{'calendar-control-label':!isSingleTemplate}" [style.width.px]="eventLabelWidth">
                        <span>{{'calendar.location' | stringLiterals}}: </span>
                    </div>
                    <div class="location" [ngClass]="{'location-addin ':isSingleTemplate}" tid="location">
                        <div>
                            <input class="tam-input" [style.width.px]="eventContentWidth"
                                [(ngModel)]="locationShowInScreen" #locationInput
                                (ngModelChange)="changeValueStreet($event)" placeholder="" [maxLength]="128"
                                [ngClass]="{'width100':isSingleTemplate}" />
                            <smart-icon class="contact-street" title="Address lookup"
                                [name]="isShowSearchAddress?'searchAddress':'searchAddress-o'"
                                (click)="clickSearchAddress()"></smart-icon>
                        </div>
                        <tam-dashboard-map-autocomplete *ngIf="isShowSearchAddress" class="contact-autocomplete"
                            [config]="mapConfig" (eventSubject$)="setSelectedAddress($event)">
                        </tam-dashboard-map-autocomplete>
                        <label class="item-label-error">
                            {{hintContentStreet}}
                        </label>
                    </div>
                </div>
                <!-- location-->

                <!--Participants-->

                <div class="control" [ngClass]="{'single-layer-control':isSingleTemplate}" tid="Participants">
                    <div [ngClass]="{'calendar-control-label':!isSingleTemplate}" [style.width.px]="eventLabelWidth">
                        <span>{{'calendar.participants' | stringLiterals}}:</span>
                    </div>
                    <kendo-multiselect #entitylist class="calendar-type-list" [style.width.px]="eventContentWidth"
                        [ngClass]="{'width100':isSingleTemplate}" [data]="dataItems" [filterable]="true"
                        (open)="onOpen($event)" (filterChange)="participantsFilter($event)" [autoClose]="true"
                        [textField]="'name'" [valueField]="'id'" [(ngModel)]="selectParticipantItems"
                        (valueChange)="valueChangeForParticipant($event)" (keydown.esc)="onEnter($event)">

                        <ng-template kendoDropDownListFooterTemplate>
                            <div *ngIf="flyValue" class="dropdown-fly-item" (click)="createContactOntheFly()">
                                <span>{{flyValue}} {{'general.new_contact' | stringLiterals}}</span>
                            </div>
                        </ng-template>
                    </kendo-multiselect>
                    <div *ngIf="invliadContactList.length>0">
                        <div> {{'addin.below_contacts_are_not_tamale_contacts' | stringLiterals}}</div>
                        <label *ngFor="let item of invliadContactList; last as isLast" class="light-color"
                            (click)="clickInvalidContact(item)">{{item.displayName}}{{isLast ? '':', '}}</label>
                    </div>
                </div>
                <!--Participants-->

                <!--date range-->

                <div *ngIf="!isSingleTemplate" class="control" tid="When">
                    <span class="calendar-control-label" [style.width.px]="eventLabelWidth">{{'calendar.when' |
                        stringLiterals}}:</span>
                    <div class="calendar-type-list" [style.width.px]="eventContentWidth">
                        <div class="calendar-date-start">
                            <kendo-datepicker calendarType="classic" [(value)]="dateStartValue"
                                (valueChange)="dateStartChange($event)" [rangeValidation]="false" [min]="min"
                                [max]="max" [disabled]="readOnly" (blur)="inputStartDateBlur()" style="width:100%">
                            </kendo-datepicker>
                        </div>
                        <div class="calendar-time-start">

                            <time-select-dropdown (clickss)="timeStartClick($event)" (timeBlur)="startTimeBlur($event)"
                                [(myModel)]="inputStartTime" (timeModelChange)="onStartTimeChange($event)"
                                [disabled]="allDay">
                            </time-select-dropdown>

                        </div>
                        <div class="calendar-end-label">
                            <span>{{'calendar.to' | stringLiterals}}</span>
                        </div>
                        <div class="calendar-date-end">
                            <kendo-datepicker calendarType="classic" [(value)]="dateEndValue" style="width:100%"
                                (valueChange)="dateEndChange($event)" [rangeValidation]="false" [min]="dateStartValue"
                                (blur)="inputEndDateBlur()" [max]="max" [disabled]="readOnly">
                            </kendo-datepicker>
                        </div>

                        <div class="calendar-time-end">
                            <time-select-dropdown (clickss)="timeEndClick($event)" (timeBlur)="endTimeBlur($event)"
                                [(myModel)]="inputEndTime" (timeModelChange)="onEndTimeChange($event)"
                                [disabled]="allDay">
                            </time-select-dropdown>
                        </div>
                        <div class="calendar-time-checkbox">
                            <div class="checkbox">
                                <label tam-checkbox [(ngModel)]="allDay"
                                    (click)="oncheckedChange($event)"><span>{{'calendar.all_day_event' |
                                        stringLiterals}}</span></label>
                            </div>
                        </div>
                    </div>

                </div>

                <!--date reange addin-->

                <div *ngIf="isSingleTemplate" class="control single-layer-control">
                    <!--start-->
                    <span [style.width.px]="eventLabelWidth">{{'calendar.when' | stringLiterals}}:</span>
                    <div class="calendar-type-list single-layer-date" [style.width]="'100%'">
                        <kendo-datepicker calendarType="classic" [(value)]="dateStartValue"
                            (valueChange)="dateStartChange($event)" [rangeValidation]="false" [min]="min" [max]="max"
                            [disabled]="readOnly" (blur)="inputStartDateBlur()" style="width:100%">
                        </kendo-datepicker>

                        <time-select-dropdown (clickss)="timeStartClick($event)" (timeBlur)="startTimeBlur($event)"
                            [(myModel)]="inputStartTime" (timeModelChange)="onStartTimeChange($event)"
                            [disabled]="allDay">
                        </time-select-dropdown>
                    </div>
                </div>
                <!--end-->
                <div *ngIf="isSingleTemplate" class="control single-layer-control">
                    <span [style.width.px]="eventLabelWidth">{{'addin.to' |
                        stringLiterals}}:</span>
                    <div class="calendar-type-list single-layer-date" [style.width]="'100%'">
                        <kendo-datepicker calendarType="classic" [(value)]="dateEndValue" style="width:100%"
                            (valueChange)="dateEndChange($event)" [rangeValidation]="false" [min]="dateStartValue"
                            (blur)="inputEndDateBlur()" [max]="max" [disabled]="readOnly">
                        </kendo-datepicker>

                        <time-select-dropdown (clickss)="timeEndClick($event)" (timeBlur)="endTimeBlur($event)"
                            [(myModel)]="inputEndTime" (timeModelChange)="onEndTimeChange($event)" [disabled]="allDay">
                        </time-select-dropdown>

                    </div>


                </div>

                <div *ngIf="isSingleTemplate" [ngClass]="{'calendar-time-checkbox':!isSingleTemplate}">
                    <div class="checkbox">
                        <label tam-checkbox [(ngModel)]="allDay"
                            (click)="oncheckedChange($event)"><span>{{'calendar.all_day_event' |
                                stringLiterals}}</span></label>
                    </div>
                </div>
                <!--date range-->
            </div>

            <div class="template-container">
                <!--Multiple combinations  layouts-->
                <tam-template *ngIf="!isSingleTemplate" [config]="_tplConfig" [valueChangeSubject]="valueChangeSubject"
                    (publishEvent)="publish()" [noteBodySubject]="_noteBodySubject" [publishSubject]="_publishSubject$">
                </tam-template>
                <!--single layer layouts-->
                <tam-single-template *ngIf="isSingleTemplate" [config]="singleLayerConfig"
                    [valueChangeSubject]="valueChangeSubject" (publishEvent)="publish()"
                    [noteBodySubject]="_noteBodySubject" [publishSubject]="_publishSubject$"></tam-single-template>
            </div>


            <div class="upload-container">
                <note-attachments [config]="noteAttachmentsConfig">
                </note-attachments>
            </div>
        </div>
        <input id="hidden-note-dialog" class="hidden-input" value={{dialogWidthForPlugin}} />
        <input id="hidden-note-dialog-open-status" class="hidden-input" value={{isDialogClosedForPlugin}} />
    </ng-template>

    <ng-template #footer>
        <div class="duplicate-tip" *ngIf="isShowDuplicateTip">
            <div class="event-duplicate">{{'addin.event_duplicate_1' |stringLiterals}}
                <span class="template-reload" (click)="onClickViewDuplicateEvent()">{{'addin.event_duplicate_2'
                    |stringLiterals}}</span>
                {{'addin.event_duplicate_3' |stringLiterals}} <span class="template-reload"
                    (click)="publish()">{{'addin.event_duplicate_4' |stringLiterals}}</span>
            </div>
        </div>
        <div class="event-footer-button">
            <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button dialog-cancel"
                (click)="onCancelBtnClick($event)" [disabled]="isAutoSaving&&!editingEntryId">{{'general.cancel' |
                stringLiterals}}</button>
            <button tam-button tamType="primary" tamSize="normal" class="dialog-button dialog-publish"
                (click)="publish(isOfficeAddinMode)" [tamLoading]="publishButtonHasBeenClicked"
                [disabled]="attachmentUploading||attachmentRenaming||publishButtonHasBeenClicked||(isAutoSaving&&!editingEntryId)||this.isShowDuplicateTip">{{'general.publish'
                | stringLiterals}}</button>
        </div>

    </ng-template>
</tam-dialog>

<div class="addin-notification-container" *ngIf="isDialogHidden">
    <div class="header-line split"></div>
    <div class="content">
        <div class="note-created-success">{{addinSuccessTip}}</div>
        <div class="icon-check">
            <smart-icon class="aacl-icon" name="check-circle"></smart-icon>
        </div>
        <div class="subject" (click)="onSubjectClick()">{{addinSubject}}</div>
    </div>
    <div class="footer-line split"></div>
    <div *ngIf="isShowBtnClose" class="footer">
        <button tam-button tamType="primary" tamSize="normal" class="dialog-button"
            (click)="onCloseBtnClick()">{{'addin.close'
            | stringLiterals}}</button>
    </div>
</div>

<tam-duplicate-event (updateEvent)="clickUpdateEvent($event)"></tam-duplicate-event>